module.exports = __webpack_public_path__ + "static/media/shweta_jadhav.ff9c3598.png";